module.exports = __webpack_public_path__ + "img/round-table.9cb2d139.png";